import { CREATE_CATEGORY_SUCCESS,
         CREATE_FILE_SUCCESS, 
         EDIT_CATEGORY_SUCCESS,
         DELETE_CATEGORY_SUCCESS,
         EDIT_FILE_SUCCESS,
         DELETE_FILE_SUCCESS,
         SET_CATMO_CATEGORIES,
         SET_SARA_NODE_ID,
         SET_CATMO_NODE_ID,
         DELETE_CATMO_CATEGORY,
        
        

      } from '../actions/docCategoryAction';




const initialState = {
  categoriesFiles: {
    uncategorizedFiles: [],
    categories: [],
    saraNodeId: null,
    catmoNodeId: null,
    deletedCategoryIds: [],
  }
};


export default function docCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_CATEGORY_SUCCESS:
  // console.log("New Category Payload:", action.payload);
  console.log("Redux State Before Update:", state);
  
  const parentId = action.payload.parent;
  
  const isTopLevel = !parentId || parentId === "sara" ||
    (typeof parentId === "string" && parentId.toLowerCase() === "null");
  
 

  if(isTopLevel){ 
    // Add as top-level category
    return {
      ...state,
      categoriesFiles: {
        ...state.categoriesFiles,
        categories: [...state.categoriesFiles.categories, {
          ...action.payload,
          files: [],
          categories: [],
          isFile: false,
        }]
      }
    };
  } else {
    // Add as subcategory to its parent
    const addSubcategoryToParent = (categories) => {
      return categories.map(category => {
        if (category.id === parentId) {
          return {
            ...category,
            categories: [...(category.categories || []), {
              ...action.payload,
              files: [],
              categories: [],
              isFile: false
            }]
          };
        }
        
        if (category.categories && category.categories.length > 0) {
          return {
            ...category,
            categories: addSubcategoryToParent(category.categories)
          };
        }
        
        return category;
      });
    };
    
    return {
      ...state,
      categoriesFiles: {
        ...state.categoriesFiles,
        categories: addSubcategoryToParent(state.categoriesFiles.categories)
      }
    };
  }
      
    case CREATE_FILE_SUCCESS:
      // console.log("CREATE_FILE_SUCCESS action received:", action.payload);
      // console.log("Reducer received action:", action.type);
      
      
      const parentCategoryId = action.payload.parentCategoryId || action.payload.parent;
      // console.log("parentCategoryId in reducer:", parentCategoryId);
      // console.log("Will go to categorized branch:", !!parentCategoryId);

      if (parentCategoryId) { 
        // Create the new file object
        const newFile = {
          ...action.payload,
          id: action.payload.id,
          name: action.payload.name,
          doc_type: action.payload.doc_type,
          // file: action.payload.file || action.payload.url, 
          // url: action.payload.file || action.payload.url,
          parent: parentCategoryId,
          parentCategoryId: parentCategoryId, 
          createdBy: action.payload.created_by || action.payload.author || 'Sara User Interface',
          lastUpdated: action.payload.modified || action.payload.created,
          created: action.payload.created,
          isFile: true,
          // object_id: action.payload.object_id,
          // mime_content_type: action.payload.mime_content_type,
          // mimeType: action.payload.mime_content_type || action.payload.mimeType,
          // alarm_device_types: action.payload.alarm_device_types || [],
          // alarm_devices: action.payload.alarm_devices || []

        };
          
        // Function to find a category by ID and add the file to it
        const addFileToCategory = (categories) => {
          return categories.map(category => {
            // Check if this is the parent category
            if (category.id === parentCategoryId) {
              return {
                ...category,
                files: [...(category.files || []), newFile]
              };
            }
            
            // If this category has subcategories, recursively check them
            if (category.categories && category.categories.length > 0) {
              return {
                ...category,
                categories: addFileToCategory(category.categories)
              };
            }
            
            // Return unchanged if not the parent
            return category;
          });
        };
        
        // Update the state with the new file in the correct category
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            categories: addFileToCategory(state.categoriesFiles.categories)
          }
        };
      } else {
        // Handle uncategorized files - ensure proper structure
        // console.log("Processing uncategorized file in reducer");
        const uncategorizedFile = {
          ...action.payload,
          id: action.payload.id,
          name: action.payload.name,
          doc_type: action.payload.doc_type,
          file: action.payload.file || action.payload.url,
          url: action.payload.file || action.payload.url,
          parent: null,
          parentCategoryId: null,
          createdBy: action.payload.created_by || action.payload.author || 'Sara User Interface',
          lastUpdated: action.payload.modified || action.payload.created,
          created: action.payload.created,
          isFile: true
        };
        
        // console.log("Adding uncategorized file to state:", uncategorizedFile);
        // console.log("Current uncategorizedFiles length:", state.categoriesFiles.uncategorizedFiles.length);
        
        const newState = {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            uncategorizedFiles: [...state.categoriesFiles.uncategorizedFiles, uncategorizedFile]
          }
        };
        
        
        return newState;
      }

    case EDIT_CATEGORY_SUCCESS:
      // console.log("EDIT_CATEGORY_SUCCESS received:", action.payload);
      
      // Function to update a category anywhere in the tree
      const updateCategoryRecursively = (categories) => {
        return categories.map(category => {
          if (category.id === action.payload.id) {
            // Get the updated device associations from the payload
            const updatedDeviceTypes = action.payload.alarm_device_types || [];
            const updatedDeviceIds = action.payload.alarm_devices || [];
            
            // Create the updated category
            const updatedCategory = {
              ...action.payload,
              files: category.files || [],
              categories: category.categories || [],
              isFile: false,
              modified: action.payload.modified || new Date().toISOString()
            };
            
            // If this category has files, update their device associations
            if (updatedCategory.files && updatedCategory.files.length > 0) {
              updatedCategory.files = updatedCategory.files.map(file => ({
                ...file,
                alarm_device_types: updatedDeviceTypes,
                alarm_devices: updatedDeviceIds
              }));
            }
            
            return updatedCategory;
          }
          
          // If this category has subcategories, recursively check them
          if (category.categories && category.categories.length > 0) {
            return {
              ...category,
              categories: updateCategoryRecursively(category.categories)
            };
          }
          
          return category;
        });
      };
      
      return {
        ...state,
        categoriesFiles: {
          ...state.categoriesFiles,
          categories: updateCategoryRecursively(state.categoriesFiles.categories)
        }
      };

    case DELETE_CATEGORY_SUCCESS:
      // console.log("DELETE_CATEGORY_SUCCESS received:", action.payload);
      
      if (action.payload && action.payload.categoryId) {
        const categoryIdToDelete = action.payload.categoryId;
        // console.log("Removing category with ID:", categoryIdToDelete);
        
        // Function to recursively filter out the category to delete
        const filterCategoriesRecursively = (categories) => {
          // First filter out the category if it's at this level
          const filteredCategories = categories.filter(category => category.id !== categoryIdToDelete);
          
          // Then check each remaining category's subcategories
          return filteredCategories.map(category => {
            if (category.categories && category.categories.length > 0) {
              return {
                ...category,
                categories: filterCategoriesRecursively(category.categories)
              };
            }
            return category;
          });
        };
        
        // Apply the recursive filtering to the categories
        const updatedCategories = filterCategoriesRecursively(state.categoriesFiles.categories);
        
        console.log("Categories after recursive filter:", updatedCategories);
        
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            categories: updatedCategories,
            deletedCategoryIds: [...(state.categoriesFiles.deletedCategoryIds || []), categoryIdToDelete]
          }
        };
      } else {
        // console.log("No category ID found in payload:", action.payload);
        return state;
      }

    case EDIT_FILE_SUCCESS:
      // console.log("EDIT_FILE_SUCCESS received:", action.payload);
      // Get the file and parent IDs
      const fileId = action.payload.id;
      // For UI purposes, use parentCategoryId to determine categorization status
      // parentCategoryId null means uncategorized, regardless of parent value (which may be catmoNodeId/saraNodeId for lineage)
      const newParentId = action.payload.parentCategoryId;
      
      // Find the file in both categorized and uncategorized files
      let originalFile = null;
      let wasUncategorized = false;
      let originalParentId = null;
      
      // Check uncategorized files first
      const uncategorizedFile = state.categoriesFiles.uncategorizedFiles.find(f => f.id === fileId);
      if (uncategorizedFile) {
        originalFile = uncategorizedFile;
        wasUncategorized = true;
      }
      
      // Find file in categories if not found in uncategorized
      const findFileInCategories = (categories) => {
        for (const category of categories) {
          if (category.files) {
            const file = category.files.find(f => f.id === fileId);
            if (file) {
              originalParentId = category.id;
              return file;
            }
          }
          if (category.categories) {
            const file = findFileInCategories(category.categories);
            if (file) return file;
          }
        }
        return null;
      };
      
      if (!originalFile) {
        originalFile = findFileInCategories(state.categoriesFiles.categories);
      }
      
      // Case 1: Moving from uncategorized to categorized
      if (wasUncategorized && newParentId) {
        // Remove from uncategorized files
        const updatedUncategorized = state.categoriesFiles.uncategorizedFiles.filter(f => f.id !== fileId);
        
        // Add to target category
        const addFileToCategory = (categories) => {
          return categories.map(category => {
            if (category.id === newParentId) {
              return {
                ...category,
                files: [...(category.files || []), {
                  ...action.payload,
                  parent: newParentId,
                  parentCategoryId: newParentId,
                  isFile: true,
                  modified: action.payload.modified || new Date().toISOString()
                }]
              };
            }
            
            if (category.categories && category.categories.length > 0) {
              return {
                ...category,
                categories: addFileToCategory(category.categories)
              };
            }
            
            return category;
          });
        };
        
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            uncategorizedFiles: updatedUncategorized,
            categories: addFileToCategory(state.categoriesFiles.categories)
          }
        };
      }
      
      // Case 2: Moving from categorized to uncategorized
      if (!wasUncategorized && (!newParentId || newParentId === null)) {
        // Remove from categories
        const removeFromCategories = (categories) => {
          return categories.map(category => ({
            ...category,
            files: category.files ? category.files.filter(f => f.id !== fileId) : [],
            categories: category.categories ? removeFromCategories(category.categories) : []
          }));
        };
        
        // Add to uncategorized files
        const uncategorizedFile = {
          ...action.payload,
          parent: null,
          parentCategoryId: null,
          isFile: true,
          modified: action.payload.modified || new Date().toISOString()
        };
        
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            categories: removeFromCategories(state.categoriesFiles.categories),
            uncategorizedFiles: [...state.categoriesFiles.uncategorizedFiles, uncategorizedFile]
          }
        };
      }
      
      // Case 3: Updating within same context (categorized to categorized or uncategorized to uncategorized)
      if (wasUncategorized && (!newParentId || newParentId === null)) {
        // Update uncategorized file
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            uncategorizedFiles: state.categoriesFiles.uncategorizedFiles.map(file => 
              file.id === fileId ? { 
                ...file, 
                ...action.payload,
                id: fileId, 
                parent: action.payload.parent || file.parent, // Use updated parent from middleware (for Catmo lineage preservation)
                parentCategoryId: null, // Always null for uncategorized files in UI
                hasCatmoLineage: file.hasCatmoLineage, // Preserve lineage
                doc_type: action.payload.doc_type || file.doc_type, 
                file: action.payload.file || action.payload.url || file.file,
                url: action.payload.file || action.payload.url || file.url,
                modified: action.payload.modified || new Date().toISOString(),
                isFile: true 
              } : file
            )
          }
        };
      }
      
      // Case 4: Moving between categories or updating within same category
      const updateFileInCategory = (category) => {
        if (category.id === newParentId) {
          // Check if file already exists in this category
          const fileExists = category.files && category.files.some(f => f.id === fileId);
          
          if (fileExists) {
            // Update existing file in this category
            return {
              ...category,
              files: category.files.map(file => 
                file.id === fileId ? { 
                  ...file,
                  ...action.payload,
                  parent: newParentId,
                  parentCategoryId: newParentId,
                  modified: action.payload.modified || new Date().toISOString(), 
                  isFile: true 
                } : file
              )
            };
          } else {
            // Add file to this category (moving from another category)
            return {
              ...category,
              files: [...(category.files || []), {
                ...action.payload,
                parent: newParentId,
                parentCategoryId: newParentId,
                isFile: true,
                modified: action.payload.modified || new Date().toISOString()
              }]
            };
          }
        }
        
        // Remove file from old category if moving
        if (category.id === originalParentId && originalParentId !== newParentId) {
          return {
            ...category,
            files: category.files ? category.files.filter(f => f.id !== fileId) : []
          };
        }
        
        // Check subcategories
        if (category.categories && category.categories.length > 0) {
          return {
            ...category,
            categories: category.categories.map(updateFileInCategory)
          };
        }
        
        return category;
      };
      
      return {
        ...state,
        categoriesFiles: {
          ...state.categoriesFiles,
          categories: state.categoriesFiles.categories.map(updateFileInCategory)
        }
      };
      
    case DELETE_FILE_SUCCESS:
      // console.log("DELETE_FILE_SUCCESS received:", action.payload);
      
      if (action.payload && action.payload.fileId && action.payload.parentId) {
        const fileIdToDelete = action.payload.fileId;
        const parentCategoryId = action.payload.parentId;
        console.log("Removing file with ID:", fileIdToDelete, "from parent category:", parentCategoryId);
    
        // Function to find and update a category in the nested structure
        const updateCategoryFiles = (categories) => {
          return categories.map(category => {
            // If this is the parent category, filter out the deleted file
            if (category.id === parentCategoryId) {
              // console.log("Found parent category:", category.name);
              // console.log("Before removal - Files count:", category.files?.length || 0);
              
              return {
                ...category,
                files: (category.files || []).filter(file => file.id !== fileIdToDelete)
              };
            }
            
            // If this category has subcategories, recursively update them
            if (category.categories && category.categories.length > 0) {
              return {
                ...category,
                categories: updateCategoryFiles(category.categories)
              };
            }
            
            // Otherwise return the category unchanged
            return category;
          });
        };
        
        // Create updated categories with the file removed
        const updatedCategories = updateCategoryFiles(state.categoriesFiles.categories);
        // console.log("Categories updated after file removal");
        
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            categories: updatedCategories
          }
        };
      } else if (action.payload && action.payload.fileId) {
        // Check if it's an uncategorized file
        const fileIdToDelete = action.payload.fileId;
        console.log("Removing uncategorized file with ID:", fileIdToDelete);
        
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            uncategorizedFiles: state.categoriesFiles.uncategorizedFiles.filter(
              file => file.id !== fileIdToDelete
            )
          }
        };
      } else {
        // console.log("Missing file ID or parent ID in payload:", action.payload);
        return state;
      }
     
      case SET_CATMO_CATEGORIES:
        // Extract CATMO categories from the payload
        const catmoCategories = action.payload.categories || [];
  
        // console.log("SET_CATMO_CATEGORIES received categories:", 
        //             catmoCategories.length, 
        //             "Sara node present:", 
        //             catmoCategories.some(c => c.name?.toLowerCase() === 'sara'));
        
        const processCategoryFiles = (category) => {
          // List of deleted category IDs
          const deletedIds = state.categoriesFiles.deletedCategoryIds || [];

          // Skip processing if this category is in the deleted list
          if (deletedIds.includes(category.id)) {
            return null;
          }

          // Process any files in this category
          const processedFiles = (category.files || []).map(file => ({
            ...file,
            file: file.file || file.url,  
            url: file.url || file.file    
          }));
          
          // Process subcategories recursively
          const processedSubcategories = (category.categories || [])
            .map(subcat => processCategoryFiles(subcat))
            .filter(subcat => subcat !== null); // Filter out any null results (deleted categories)
          
          
          return {
            ...category,
            files: processedFiles,
            categories: processedSubcategories,
            alarm_device_types: category.alarm_device_types || [],
            alarm_devices: category.alarm_devices || [],
            alarmDeviceTypes: category.alarm_device_types || category.alarmDeviceTypes || [],
            alarmDevices: category.alarm_devices || category.alarmDevices || [],
          };
        };

        // Find Sara node in the incoming data
        const saraNode = catmoCategories.find(cat => 
          cat.name && cat.name.toLowerCase() === 'sara'
        );
        
        // Get all non-Sara categories from the incoming data
        const nonSaraIncomingCategories = catmoCategories.filter(cat => 
          !(cat.name && cat.name.toLowerCase() === 'sara')
        );
        
        // Get IDs of incoming categories for duplicate prevention
        const incomingIds = catmoCategories.map(cat => cat.id);
        
        // Find existing Sara node in local state
        const existingSaraNode = state.categoriesFiles.categories.find(cat => 
          (cat.name && cat.name.toLowerCase() === 'sara') || 
          (cat.id === state.categoriesFiles.saraNodeId)
        );
        
        
        // Process non-Sara categories normally
        const processedNonSaraCategories = nonSaraIncomingCategories.map(cat => 
          processCategoryFiles(cat)
        );
        
        // Special handling for Sara: merge incoming structure with local files
        let mergedSaraNode = null;
        
        if (saraNode) {
          console.log("Incoming Sara node details:", {
            id: saraNode.id,
            name: saraNode.name,
            childrenCount: saraNode.categories?.length || 0
          });
          
          // Log all incoming Sara categories and their files
          if (saraNode.categories) {
            saraNode.categories.forEach(cat => {
              console.log(`Incoming Sara child: ${cat.name} (ID: ${cat.id})`, {
                filesCount: cat.files?.length || 0,
                filesWithUrls: cat.files?.filter(f => f.file || f.url).length || 0
              });
            });
          }
        } else if (existingSaraNode) {
          // No incoming Sara, but we have a local one - keep it
          console.log("No incoming Sara node, keeping existing one");
          mergedSaraNode = existingSaraNode;
        }
        
        // Find any local categories that aren't in the incoming data and aren't Sara
        const localOnlyCategories = state.categoriesFiles.categories.filter(cat => 
          !incomingIds.includes(cat.id) && 
          !(cat.name && cat.name?.toLowerCase() === 'sara') &&
          cat.id !== state.categoriesFiles.saraNodeId
        );
        
        // console.log("Local-only categories count:", localOnlyCategories.length);
        
        // Build final categories list
        const finalCategories = [
          ...processedNonSaraCategories,
          ...(mergedSaraNode ? [mergedSaraNode] : []),
          ...localOnlyCategories
        ];
          return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            categories: finalCategories,
            saraNodeId: saraNode?.id || existingSaraNode?.id || state.categoriesFiles.saraNodeId,
            uncategorizedFiles: action.payload.uncategorizedFiles || []
          }
        };
      case SET_SARA_NODE_ID:
        return {
          ...state,
          saraNodeId: action.payload,
          categoriesFiles: {
            ...state.categoriesFiles,
            saraNodeId: action.payload  
          }
        };

      case SET_CATMO_NODE_ID:
        return {
          ...state,
          catmoNodeId: action.payload,
          categoriesFiles: {
            ...state.categoriesFiles,
            catmoNodeId: action.payload  
          }
        };

      case DELETE_CATMO_CATEGORY:
        if (!state.categoriesFiles.deletedCategoryIds.includes(action.payload)) {
        return {
          ...state,
          categoriesFiles: {
            ...state.categoriesFiles,
            deletedCategoryIds: [...(state.categoriesFiles.deletedCategoryIds || []), action.payload]
          }
        };
      }
      return state;
   

    default:
      return state;
  }
}


